module.exports = __webpack_public_path__ + "static/media/13.44d5a3f1.jpg";